<template>
  <div class="w-full h-full relative">
    <div v-if="isLoading" class="absolute w-full top-0 left-0 h-full">
      <vue-element-loading
        :active="isLoading"
        spinner="spinner"
        duration="1.5"
        color="#4f4f4f"
        size="50"
      />
    </div>
    <sub-folder-empty v-if="subFolderEmptyList" :folder-name="folderName"/>
    <sub-folder-list v-else @isEmptyList="subFolderEmpty" />
  </div>
</template>
<script>
import SubFolderEmpty from '@/modules/Folders/components/SubFolderEmpty'
import SubFolderList from '@/modules/Folders/components/SubFolderList'
import VueElementLoading from "vue-element-loading";
import useFolderState from '@/modules/Folders/hooks/useFolderState'
const {
  state: paginationStore,
  setPagination,
  resetSubFolderParams,
} = useFolderState()
export default {
  name: 'SubFolder',
  components: {
    SubFolderEmpty,
    SubFolderList,
    VueElementLoading
  },
  provide() {
    return {
      setPagination,
      resetSubFolderParams,
      paginationStore
    }
  },
  data() {
    return {
      subFolderEmptyList: false,
      isLoading: false,
      folderName: this.$route.params.folderName
    }
  },
  mounted() {
    this.isLoading = true
  },
  methods: {
    subFolderEmpty(value, name) {
      this.subFolderEmptyList = value
      this.folderName = name
      this.isLoading = false
    }
  }
}
</script>
